export default function useDecryptSymbols() {
  function decryptSymbols(input) {
    if (Array.isArray(input)) {
      return input.map((item) => {
        return decryptSymbols(item);
      });
    } else if (typeof input === 'object' && input !== null) {
      return Object.keys(input).reduce((acc, key) => {
        acc[key] = decryptSymbols(input[key]);
        return acc;
      }, {});
    } else {
      return decryptString(input);
    }
  }

  function encryptSymbols(input) {
    if (Array.isArray(input)) {
      return input.map((item) => {
        return encryptSymbols(item);
      });
    } else if (typeof input === 'object' && input !== null) {
      return Object.keys(input).reduce((acc, key) => {
        acc[key] = encryptSymbols(input[key]);
        return acc;
      }, {});
    } else {
      return encryptString(input);
    }
  }

  function decryptString(input) {
    if (typeof input !== 'string') return input;
    if (!input.replace) return input;
    return input.replace(/``5C/g, '\\').replace(/``23/g, '#').replace(/``amp/g, '&').replace(/``2F/g, '/').replace(/``2B/g, '+').replace(/``21/g, '!').replace(/``3D/g, '=').replace(/``25/g, '%').replace(/``dbq/g, '"');
  }

  function encryptString(input) {
    if (typeof input !== 'string') return input;
    if (!input.replace) return input;
    return input.replace(/\\/g, '``5C').replace(/#/g, '``23').replace(/&/g, '``amp').replace(/\//g, '``2F').replace(/\+/g, '``2B').replace(/!/g, '``21').replace(/=/g, '``3D').replace(/%/g, '``25').replace(/"/g, '``dbq');
  }

  return {
    decryptSymbols,
    encryptSymbols,
  };
}
